// Cross-tab auth session coordination. Uses BroadcastChannel so an explicit
// user logout in one tab can notify others, WITHOUT piggybacking on
// localStorage 'storage' events (which also fire on every tab boot and on
// localStorage.clear(), causing false logout signals).

const CHANNEL_NAME = 'auth_session';
type AuthMessage = { type: 'logout' };

let _channel: BroadcastChannel | null = null;

const getChannel = (): BroadcastChannel | null => {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!_channel) _channel = new BroadcastChannel(CHANNEL_NAME);
  return _channel;
};

export const broadcastLogout = (): void => {
  const ch = getChannel();
  if (ch) ch.postMessage({ type: 'logout' } as AuthMessage);
};

export const onLogoutBroadcast = (callback: () => void): (() => void) => {
  const channel = getChannel();
  if (!channel) return () => {};
  const handler = (event: MessageEvent<AuthMessage>) => {
    if (event.data && event.data.type === 'logout') callback();
  };
  channel.addEventListener('message', handler);
  return () => channel.removeEventListener('message', handler);
};
